import { render, staticRenderFns } from "./DicasSaude.vue?vue&type=template&id=9421b8fe&scoped=true&"
import script from "./DicasSaude.vue?vue&type=script&lang=js&"
export * from "./DicasSaude.vue?vue&type=script&lang=js&"
import style0 from "./DicasSaude.vue?vue&type=style&index=0&id=9421b8fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9421b8fe",
  null
  
)

export default component.exports